<template>
    <div class="main">
        <div class="box1" v-if="isNolist">
            <img src="../assets/empty/ic_wuxingxi.png" />
            <p class="tip1">{{message}}</p>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            message: {
                type: String,
                default: '暂无数据'
            },
            isNolist: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {

            }
        }
    }
</script>
<style lang="less" scoped>
.main {
    .box1 {
        text-align: center;
        margin-top: 216px;
        img {
            display: inline-block;
            width: 74px;
            height: 62px;
        }
        .tip1 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 24px;
        }
        .tip2 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 8px;
        }
    }
}
</style>
